﻿define([
    'jquery',
    'pubsub',
    'overLay',
    'moduleUtilities',
    'generalUtilities',
    'validator',
    'connectButtonCompiled',
    'relationshiptypesData',
    'sendMessageCompiled',
    'connectionUtilities',
    'connectionService',
    'imService',
    'messageControl2'
], function(
    $,
    pubsub,
    overLay,
    moduleUtilities,
    generalUtilities,
    validator,
    connectButtonCompiled,
    relationshiptypesData,
    sendMessageCompiled,
    connectionUtilities
) {
    /**
     * re_connection_control
     * @exports connectionControl
     * @author Elina Goldin
     */

    //#region set up

    'use strict';

    var module, selectors, elements, overLayModule, constraints;

    module = {};
    module.private = {};
    module.properties = {};
    selectors = {
        connectBtn: '.js-connect-btn',
        sendmessageForm: '#sendmessageForm'
    };
    elements = {};

    constraints = {
        message: {
            length: {
                maximum: 400,
                message: ['^', 'Maximum 400 characters'].join(' ')
            }
        }
    };

    // Initialize overlay.
    overLayModule = new overLay();
    overLayModule.init();

    //#endregion

    /**
     * Connection response error handler
     * @param {object} e event
     * @param {object} data response data
     */
    module.private.handleDataConnectionError = function(e, data) {
        var errorMsg, submitBtn;

        //remove element before creating loggly message
        if (data.element) {
            delete data.element;
        }

        pubsub.publish('loggly.error', { message: JSON.stringify(data) });

        errorMsg =
            data.response.SaveResult.Message === window.RESAAS.Localization.Global.RELATIONSHIP_ALREADY_EXISTS
                ? window.RESAAS.Localization.Global.RELATIONSHIP_ALREADY_EXISTS
                : RESAAS.Localization.Global.GENERIC_WEBSERVICE_ERROR_MESSAGE;


        submitBtn = document.getElementById('submitBtn');

        if (submitBtn) {
            submitBtn.classList.remove('submitting');
        }

        overLayModule.closeOverlay(true);
        pubsub.publish('uiAction.MessageAdd', {
            message: errorMsg,
            type: 'error'
        });
    };

    /**
     * Run validator
     * @param {object} form the message form.
     */
    module.private.validateMessageForm = function validateMessageForm(form) {
        return validator.validateAndWatch(form, constraints);
    };


    module.private.handleConnectRequest = function handleConnectRequest(e, userId, connectAction, message) {
        var request, serviceObject, requestOptions;

        requestOptions = {
            connectaction: connectAction,
        };

        request = {
            contact: {
                KnownContactUserId: userId,
                InvitationMessage: message,
                Relationships: [
                    {
                        Type: relationshiptypesData.browse().Connection,
                        Action: 0                      
                    }
                ]
            }
        };

        serviceObject = moduleUtilities.createServiceObject(request, module.properties, requestOptions);

        generalUtilities.disableAndWaitFor(e.target, 'data.ConnectionAdd');

        pubsub.publish('uiHas.ConnectionAdd', serviceObject);
    };


    /**
     * Handle click on the action, connects the users
     * @param {object} e Click event
     */
    module.private.handleSendMessageSubmit = function(e) {
        e.preventDefault();

        var $currentTarget, formData, sendMessageForm, invalid, recipientUserId, connectaction;
        $currentTarget = $(e.currentTarget);
        $currentTarget.addClass('submitting');
        recipientUserId = $currentTarget.data('contactguid');
        connectaction = $currentTarget.data('connectaction');
        sendMessageForm = $(selectors.sendmessageForm);
        formData = validator.serializeObject(sendMessageForm);
        invalid = module.private.validateMessageForm(sendMessageForm);
        if (!invalid) {
            module.private.handleConnectRequest(e, recipientUserId, connectaction, formData.message);
        } else {
            $currentTarget.removeClass('submitting');
        }
    };

    /**
     * Connection response success handler
     * @param {object} e event
     * @param {object} data response data
     */
    module.private.handleDataConnectionSuccess = function(e, data) {
        var successMsg, connectAction, connectBtn, templateData, requester, receiver, html, submitBtn;

        connectAction = generalUtilities.prop(data, 'connectaction');
        receiver = generalUtilities.prop(data, 'response.SaveResult.Data.Name');
        requester = [window.RESAAS.User2.FirstName, window.RESAAS.User2.LastName].join(' ');

        //accpeting a connection
        if (connectAction === 'accept') {
            successMsg = generalUtilities.stringFormat(
                'You’re Connected! <a href="/inbox?UserId={0}">Click here </a> to start a conversation and explore new opportunities together!',
                generalUtilities.prop(data, 'response.SaveResult.Data.KnownContactUserId')
            )

            pubsub.publish('relationship.accepted', {
                type: 'connection accepted',
                requester: requester,
                receiver: receiver,
                element: 'notifications',
                content: 'relationship accepted'
            });

            pubsub.publish('uiAction.MessageAdd', {
                message: successMsg,
                autoDelete: false
            });

            //requesting a connection
        } else {
            pubsub.publish('relationship.requested', {
                type: 'connection request',
                requester: requester,
                receiver: receiver,
                element: 'agent search'
            });

            if (generalUtilities.prop(data, 'request.contact.InvitationMessage')) {
                pubsub.publish('mixpanel.AddContent', {
                    content: 'Send Message',
                    type: 'Connect request message'
                });
            }
            pubsub.publish('uiAction.MessageAdd', {
                message: 'Your connection request has been sent!',
                autoDelete: false,
                perpetuate: false
            });
        }

        //update button
        templateData = {
            connectionInfo: {
                UserId: generalUtilities.prop(data, 'response.SaveResult.Data.KnownContactUserId'),
                ImFollowing: true,
                FollowingMe: connectAction === 'accept' ? true : false,
                Connected: connectAction === 'accept' ? true : false,
            },
            greyDisabled: window.pageType === 'user-discovery'

        };

        html = connectButtonCompiled(templateData);

        connectBtn = document.querySelector('[data-contactguid="' + generalUtilities.prop(data, 'response.SaveResult.Data.KnownContactUserId') + '"]');

        if (connectBtn) {
            connectBtn.outerHTML = html;
        }

        submitBtn = document.getElementById('submitBtn');

        if (submitBtn) {
            submitBtn.classList.remove('submitting');
        }

        overLayModule.closeOverlay(true);
    };

    /**
     * Handle data event returned from service, determines success of fail and calls the corresponding function.
     * @param {object} e The pubsub event.
     * @param {object} data Data object from service.
     */
    module.private.handleDataConnectionAdd = function(e, data) {
        var success;

        success = generalUtilities.prop(data, 'response.SaveResult.Success');
        if (moduleUtilities.isOwnEvent(data, module.properties)) {
            if (!success) {
                module.private.handleDataConnectionError(e, data);
            } else {
                module.private.handleDataConnectionSuccess(e, data);
            }
        }
    };

    //#endregion

    //#region dom event handlers

    /**
     * Handle click on the action, connects the users
     * @param {object} e Click event
     */
    module.private.handleConnectionClick = function(e) {
        var $currentTarget,
            connectaction,
            recipientUserId,
            totalConnected,
            daysAgoCreated,
            canConnect,
            html,
            isPaid;

        e.preventDefault();

        $currentTarget = $(e.currentTarget);

        totalConnected = connectionUtilities.getTotalConnected();
        daysAgoCreated = generalUtilities.daysAgo(
            generalUtilities.getDateYMD(new Date()),
            generalUtilities.prop(window, 'RESAAS.User2.CreatedDate')
        );
        connectaction = $currentTarget.data('connectaction');
        recipientUserId = $currentTarget.data('contactguid');

        isPaid =
            generalUtilities.prop(window, 'RESAAS.User2.ReferralPro') ||
            generalUtilities.prop(window, 'RESAAS.User2.PremiumPlus');
        canConnect = isPaid || connectaction === 'accept' || totalConnected < 5 || daysAgoCreated < 3;

        if (canConnect) {
            e.stopPropagation();

            // accepting the request
            if (connectaction === 'accept') {
                module.private.handleConnectRequest(e, recipientUserId, connectaction, null);
            } else {
                // sending a request
                html = sendMessageCompiled({
                    ContactUserId: recipientUserId,
                    IntroMessage: generalUtilities.stringFormat(
                        window.RESAAS.Localization.Global.SEND_MESSAGE_POPUP_DESC_1,
                        $currentTarget.data('contactname')
                    ),
                    Connectaction: connectaction
                });
                overLayModule.openOverlay(html);
                var submitBtn = document.getElementById('submitBtn');
                submitBtn.addEventListener('click', function (e) {
                    module.private.handleSendMessageSubmit(e);
                });
            }

        } else {
            pubsub.publish('mixpanel.Landed', {pageType: 'community paywall', type: 'connect button'});
        }
    };

    //#endregion

    /**
     * Initiates the module, creates a guid and binds dom events.
     * @param {object} [e] The pubsub event, optional depending module is self init or by pubsub event.
     * @param {object} [data] Data passed in by pubsub event, optional depending module is self init or by pubsub event.
     */
    module.private.init = function(e, data) {
        //module config
        module.properties.guid = data && data.guid ? data.guid : generalUtilities.uuid();

        //elements
        elements.html = $('html');

        //dom event binding
        elements.html
            .off('click.connectionControl')
            .on('click.connectionControl', selectors.connectBtn, module.private.handleConnectionClick);
    };

    //#region external event bindings

    pubsub.subscribe('data.ConnectionAdd', module.private.handleDataConnectionAdd);
    module.private.init();

    //#endregion

    //expose API
    return module;
});
